export const FILE_CHANGE_STATUS = "FILE_CHANGE_STATUS";

export const FILE_CONSULTATION = "FILE_CONSULTATION";

export const COMMENT_ADD = "COMMENT_ADD";

export const INSPECTION_CHANGE = "INSPECTION_CHANGE";

export const ACTION_DO = "ACTION_DO";
